import {antiForgeryPost} from '../../../utils/fetch';
import ko from 'knockout';

function EmailSignupViewModel(data, userEmail, sourceOverride){
    this.email = ko.observable(userEmail);
    this.gender = ko.observableArray(data.gender);
    this.selectedGender = ko.observable();
    this.primary = ko.observableArray(data.primary);
    this.selectedPrimary = ko.observable();
    this.frequency = ko.observableArray(data.frequency);
    this.selectedFrequency = ko.observable();
    this.specificPrimary = ko.observableArray(data.specificPrimary);
    this.selectedSpecificPrimary = ko.observable();
    this.source = sourceOverride || 'Equine Sign-Up';
}

EmailSignupViewModel.prototype.save = function(){
    return antiForgeryPost('/api/CustomerContact/EmailSubscribe', {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            'email': this.email(),
            'frequency': this.selectedFrequency(),
            'gender': this.selectedGender(),
            'primaryRidingStyle': this.selectedPrimary(),
            'specificPrimaryRidingStyle': this.selectedSpecificPrimary(),
            'source': this.source
        })
    })
    .then(function(response){
        return response.json();
    })
    .catch(function(){
        // eslint-disable-next-line no-console
        console.error('A call to \'/api/CustomerContact/EmailSubscribe\' failed');
    });
};

export default EmailSignupViewModel;